import { useMemo } from 'react';
import dayjs from 'dayjs';
import { TIME_WITH_SECONDS_FORMAT } from '@/utils/dateFormat';

/**
 * Formats a TanStack Query `dataUpdatedAt` timestamp as "HH:mm:ss" for "last updated" labels.
 * Returns an empty string before the first successful fetch (`dataUpdatedAt` is 0).
 */
export function useLastUpdatedText(dataUpdatedAt: number | undefined): string {
  return useMemo(() => (dataUpdatedAt ? dayjs(dataUpdatedAt).format(TIME_WITH_SECONDS_FORMAT) : ''), [dataUpdatedAt]);
}
